module.exports = __webpack_public_path__ + "static/media/pic3.75790380.JPG";